import React from 'react'
import { useSelector } from 'react-redux'

import OfferTemplate from '../../templates/Offer'
import { selectors as AppSelectors } from '../../redux/app/redux'
import withMemo from '../../decorators/WithMemo'

import OfferDetailsSagas from './sagas'
import { selectors } from './redux'


const Offer = () => {
  const data = useSelector(selectors.data)
  const breadcrumb = useSelector(AppSelectors.breadcrumb)

  if (!data) {
    return null
  }

  return (
    <OfferTemplate
      data={data}
      breadcrumb={breadcrumb}
    />
  )
}

Offer.getInitialProps = async(ctx, store) => (
  store.saga.run(OfferDetailsSagas.init, ctx).done
)

Offer.propTypes = {}

export default withMemo()(Offer)
